module.exports = __webpack_public_path__ + "static/media/logo-footer.4ec91280.png";